export default __webpack_public_path__ + "static/media/advantage1.8f927c58.png";